/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CommandeDto } from '../models/commande-dto';
import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { TypeArticle } from '../models/type-article';


/**
 * Fonctions de gestion des commandes
 */
@Injectable({
  providedIn: 'root',
})
export class CommandesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation commandeGetList
   */
  static readonly CommandeGetListPath = '/api/commandes/list';

  /**
   * Renvoie la liste des commandes.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commandeGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  commandeGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<CommandeDto>>> {

    const rb = new RequestBuilder(this.rootUrl, CommandesService.CommandeGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<CommandeDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des commandes.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commandeGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commandeGetList(params?: {
  }): Observable<Array<CommandeDto>> {

    return this.commandeGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<CommandeDto>>) => r.body as Array<CommandeDto>)
    );
  }

  /**
   * Path part for operation commandeLoadList
   */
  static readonly CommandeLoadListPath = '/api/commandes/load-list';

  /**
   * Renvoie la liste des commandes (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commandeLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commandeLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, CommandesService.CommandeLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des commandes (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commandeLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commandeLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.commandeLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation commandeGet
   */
  static readonly CommandeGetPath = '/api/commandes/{id}';

  /**
   * Renvoie la commande spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commandeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  commandeGet$Response(params: {

    /**
     * Identifiant de la commande
     */
    id: number;
  }): Observable<StrictHttpResponse<CommandeDto>> {

    const rb = new RequestBuilder(this.rootUrl, CommandesService.CommandeGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommandeDto>;
      })
    );
  }

  /**
   * Renvoie la commande spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commandeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commandeGet(params: {

    /**
     * Identifiant de la commande
     */
    id: number;
  }): Observable<CommandeDto> {

    return this.commandeGet$Response(params).pipe(
      map((r: StrictHttpResponse<CommandeDto>) => r.body as CommandeDto)
    );
  }

  /**
   * Path part for operation commandePut
   */
  static readonly CommandePutPath = '/api/commandes/{id}';

  /**
   * Met à jour la commande spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commandePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commandePut$Response(params: {

    /**
     * Identifiant de la commande à mettre à jour
     */
    id: number;

    /**
     * Commande
     */
    body: CommandeDto
  }): Observable<StrictHttpResponse<CommandeDto>> {

    const rb = new RequestBuilder(this.rootUrl, CommandesService.CommandePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommandeDto>;
      })
    );
  }

  /**
   * Met à jour la commande spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commandePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commandePut(params: {

    /**
     * Identifiant de la commande à mettre à jour
     */
    id: number;

    /**
     * Commande
     */
    body: CommandeDto
  }): Observable<CommandeDto> {

    return this.commandePut$Response(params).pipe(
      map((r: StrictHttpResponse<CommandeDto>) => r.body as CommandeDto)
    );
  }

  /**
   * Path part for operation commandeDelete
   */
  static readonly CommandeDeletePath = '/api/commandes/{id}';

  /**
   * Supprime la commande spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commandeDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  commandeDelete$Response(params: {

    /**
     * Identifiant de la commande à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, CommandesService.CommandeDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la commande spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commandeDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commandeDelete(params: {

    /**
     * Identifiant de la commande à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.commandeDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation commandePost
   */
  static readonly CommandePostPath = '/api/commandes';

  /**
   * Crée la commande spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commandePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commandePost$Response(params: {

    /**
     * Commande
     */
    body: CommandeDto
  }): Observable<StrictHttpResponse<CommandeDto>> {

    const rb = new RequestBuilder(this.rootUrl, CommandesService.CommandePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommandeDto>;
      })
    );
  }

  /**
   * Crée la commande spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commandePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commandePost(params: {

    /**
     * Commande
     */
    body: CommandeDto
  }): Observable<CommandeDto> {

    return this.commandePost$Response(params).pipe(
      map((r: StrictHttpResponse<CommandeDto>) => r.body as CommandeDto)
    );
  }

  /**
   * Path part for operation commandePost2
   */
  static readonly CommandePost2Path = '/api/commandes/{typeArticle}';

  /**
   * Crée la commande spécifiée avec le type d'article spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commandePost2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commandePost2$Response(params: {

    /**
     * Type d&#x27;article
     */
    typeArticle: TypeArticle;

    /**
     * Commande
     */
    body: CommandeDto
  }): Observable<StrictHttpResponse<CommandeDto>> {

    const rb = new RequestBuilder(this.rootUrl, CommandesService.CommandePost2Path, 'post');
    if (params) {
      rb.path('typeArticle', params.typeArticle, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommandeDto>;
      })
    );
  }

  /**
   * Crée la commande spécifiée avec le type d'article spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commandePost2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commandePost2(params: {

    /**
     * Type d&#x27;article
     */
    typeArticle: TypeArticle;

    /**
     * Commande
     */
    body: CommandeDto
  }): Observable<CommandeDto> {

    return this.commandePost2$Response(params).pipe(
      map((r: StrictHttpResponse<CommandeDto>) => r.body as CommandeDto)
    );
  }

  /**
   * Path part for operation commandeValide
   */
  static readonly CommandeValidePath = '/api/commandes/statut/valide';

  /**
   * Valide la commande spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commandeValide()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commandeValide$Response(params: {

    /**
     * Commande
     */
    body: CommandeDto
  }): Observable<StrictHttpResponse<CommandeDto>> {

    const rb = new RequestBuilder(this.rootUrl, CommandesService.CommandeValidePath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommandeDto>;
      })
    );
  }

  /**
   * Valide la commande spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commandeValide$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commandeValide(params: {

    /**
     * Commande
     */
    body: CommandeDto
  }): Observable<CommandeDto> {

    return this.commandeValide$Response(params).pipe(
      map((r: StrictHttpResponse<CommandeDto>) => r.body as CommandeDto)
    );
  }

  /**
   * Path part for operation commandePrepare
   */
  static readonly CommandePreparePath = '/api/commandes/statut/prepare';

  /**
   * Prépare la commande spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commandePrepare()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commandePrepare$Response(params: {

    /**
     * Commande
     */
    body: CommandeDto
  }): Observable<StrictHttpResponse<CommandeDto>> {

    const rb = new RequestBuilder(this.rootUrl, CommandesService.CommandePreparePath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommandeDto>;
      })
    );
  }

  /**
   * Prépare la commande spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commandePrepare$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commandePrepare(params: {

    /**
     * Commande
     */
    body: CommandeDto
  }): Observable<CommandeDto> {

    return this.commandePrepare$Response(params).pipe(
      map((r: StrictHttpResponse<CommandeDto>) => r.body as CommandeDto)
    );
  }

  /**
   * Path part for operation commandeLivre
   */
  static readonly CommandeLivrePath = '/api/commandes/statut/livre';

  /**
   * Livre la commande spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commandeLivre()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commandeLivre$Response(params: {

    /**
     * Commande
     */
    body: CommandeDto
  }): Observable<StrictHttpResponse<CommandeDto>> {

    const rb = new RequestBuilder(this.rootUrl, CommandesService.CommandeLivrePath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CommandeDto>;
      })
    );
  }

  /**
   * Livre la commande spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `commandeLivre$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  commandeLivre(params: {

    /**
     * Commande
     */
    body: CommandeDto
  }): Observable<CommandeDto> {

    return this.commandeLivre$Response(params).pipe(
      map((r: StrictHttpResponse<CommandeDto>) => r.body as CommandeDto)
    );
  }

}
